import {
  GoogleAuthProvider,
  OAuthProvider,
  type AuthProvider,
} from 'firebase/auth'

export type OAuthProviderConfig = {
  /** Firebase provider ID (e.g. 'google.com', 'oidc.okta') */
  id: string
  /** Display name */
  name: string
  /** Icon asset path */
  icon: string
  /** Show as a dedicated button on the login page (vs in the overflow dropdown) */
  prominent?: boolean
  /** Factory to create a fresh Firebase AuthProvider instance */
  createProvider: () => AuthProvider
}

export const oauthProviders: OAuthProviderConfig[] = [
  {
    id: 'google.com',
    name: 'Google',
    icon: '/assets/google-icon.svg',
    prominent: true,
    createProvider: () => new GoogleAuthProvider(),
  },
  {
    id: 'microsoft.com',
    name: 'Microsoft',
    icon: '/assets/microsoft-icon.svg',
    prominent: true,
    createProvider: () => new OAuthProvider('microsoft.com'),
  },
  {
    id: 'oidc.flex-okta',
    name: 'Flex',
    icon: '/assets/flex-icon.svg',
    createProvider: () => new OAuthProvider('oidc.flex-okta'),
  },
  {
    id: 'oidc.okta-linewise',
    name: 'Okta (LineWise)',
    icon: '/assets/okta-icon.svg',
    createProvider: () => new OAuthProvider('oidc.okta-linewise'),
  },
]

/** Look up a provider config by Firebase provider ID */
export function getProviderConfig(providerId: string) {
  return oauthProviders.find((p) => p.id === providerId)
}

export const prominentProviders = oauthProviders.filter((p) => p.prominent)
export const dropdownProviders = oauthProviders.filter((p) => !p.prominent)
